module.exports = {
  MAPS_API_BASE_URL: 'api/v1/map'
};



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/windshaft/config.js
// module id = 1069
// module chunks = 6